module.exports = __webpack_public_path__ + "static/img/wood31.02d547b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wood31.jpg
// module id = m4Hx
// module chunks = 0